import React, { useCallback, useEffect, useRef, useState } from "react";
import PdfButton from "../../ui/PdfButton.jsx";
import { loadRowView } from "../../../features/shippingHub/LoadsHistory";
import { HISTORY_DAYS, LOAD_KINDS, isExternalUrl, loadRecentLoads } from "../../../features/shippingHub/shipHistory";
import { absoluteUrl } from "../../../features/signing/signRequestsApi";
import { chipClass } from "../../../features/signing/signWords";

// History on a phone: the loads of the last two weeks (the desktop's features/shippingHub/LoadsHistory: same read,
// same row words) as cards, each manifest a PdfButton (fetched with the API key, then the share sheet). Hidden on an
// API without loads. Layout only.
export default function LoadsCards({ apiBase }) {
  const [kind, setKind] = useState("");
  const [state, setState] = useState({ loading: true, loads: [], message: "", missing: false });
  const seq = useRef(0);

  const read = useCallback(async () => {
    const n = ++seq.current;
    setState((s) => ({ ...s, loading: true }));
    const r = await loadRecentLoads(apiBase, kind);
    if (n === seq.current) setState({ loading: false, loads: r.loads, message: r.message, missing: r.missing });
  }, [apiBase, kind]);

  useEffect(() => { read(); }, [read]);

  if (state.missing) return null;
  return (
    <div className="jq-block" data-testid="phone-loads-history">
      <h3>Loads, last {HISTORY_DAYS} days</h3>
      <div className="d-flex gap-2 mb-2">
        <select className="form-select" style={{ minHeight: 44 }} aria-label="Which loads" value={kind} onChange={(e) => setKind(e.target.value)}>
          {LOAD_KINDS.map((k) => <option key={k.id} value={k.id}>{k.label}</option>)}
        </select>
        <button type="button" className="btn btn-outline-secondary jq-filter-btn" aria-label="Refresh loads" disabled={state.loading} onClick={read}>
          <i className={`fas fa-sync-alt${state.loading ? " fa-spin" : ""}`} aria-hidden="true" />
        </button>
      </div>
      {state.message && <div className="jq-note jq-note-danger">Couldn't load the loads: {state.message}</div>}
      {state.loading && !state.loads.length ? (
        <div className="jq-list-state" role="status"><span className="spinner-border spinner-border-sm" aria-hidden="true" /> Loading…</div>
      ) : !state.loads.length ? (
        !state.message && <div className="jq-list-state">No loads in the last {HISTORY_DAYS} days.</div>
      ) : (
        state.loads.map((l) => {
          const v = loadRowView(l);
          return (
            <div key={l.load_id} className="jq-card" data-testid="phone-load-row">
              <div className="d-flex justify-content-between align-items-start gap-2">
                <div>
                  <div className="fw-bold" style={{ fontSize: "1.1rem" }}>{v.title}</div>
                  <div>{v.customer}</div>
                </div>
                {v.kind && <span className="jq-tag">{v.kind}</span>}
              </div>
              {v.what && <div className="small mt-1">{v.what}</div>}
              {v.who && <div className="small jq-muted">{v.who}</div>}
              {v.chips.length > 0 && (
                <div className="d-flex flex-wrap gap-1 mt-1">
                  {v.chips.map((c) => <span key={c.text} className={chipClass(c.tone)}>{c.text}</span>)}
                </div>
              )}
              <div className="mt-2">
                {v.signed && (isExternalUrl(v.signed) ? (
                  <a className="btn btn-outline-primary w-100 mb-2" style={{ minHeight: 44 }} href={v.signed} target="_blank" rel="noopener noreferrer">
                    Signed manifest
                  </a>
                ) : (
                  <PdfButton url={absoluteUrl(apiBase, v.signed)} filename={`Signed_Manifest_${v.title}.pdf`} label="Signed manifest"
                    className="btn btn-outline-primary w-100" testId="phone-load-signed" />
                ))}
                {v.manifest && (
                  <PdfButton url={absoluteUrl(apiBase, v.manifest)} filename={`Manifest_${v.title}.pdf`} label="Load manifest"
                    className="btn btn-outline-secondary w-100" testId="phone-load-manifest" />
                )}
              </div>
            </div>
          );
        })
      )}
    </div>
  );
}
